module.exports = __webpack_public_path__ + "Server-Default.AzureCloudService.c76842a0c7458101de0fe579cb045813.hashedasset.svg";